import axios from "axios";
import React from "react";
import ChoosePlan from "../../components/ChoosePlan/ChoosePlan";
import HeaderPage from "../../components/PageHeader/PageHeader";
import { retornarCookie } from "../../services/cookieservice";
import "./SelecaoPlanoElegibilidadePage.css";
import Loader from "../../components/Loader/Loader";

const { REACT_APP_API } = process.env;

export default class SelecaoPlanoElegibilidadePage extends React.Component {
  constructor(props) {
    super(props);

    this.onChangePlanoMedicina = this.onChangePlanoMedicina.bind(this);
    this.onChangePlanoOdonto = this.onChangePlanoOdonto.bind(this);
  }

  state = {
    nomeElegibilidade: undefined,
    numeroVidas: undefined,
    vidasrestantes: undefined,
    planosMedicina: [],
    planosOdonto: [],
    elegibilidades: [],
    exibeCarregamento: false,
    existePlanoMedicina: true,
    existePlanoOdonto: true,
  };

  componentDidMount() {
    this.listarPlanosMedicina();
    this.listarPlanosOdonto();
    this.carregarVidasRestantes();

    if (!this.state.existePlanoMedicina && !this.state.existePlanoOdonto) {
      alert(
        "Não existem planos medicina e odonto disponíveis nesse momento para " +
        this.props.oportunidade.QtdeVidas +
        " vida(s) e " +
        this.props.oportunidade.QtdeVidasTit +
        " titular(es)."
      );
    }
  }

  async carregarVidasRestantes() {
    const IdAgenteVendas = retornarCookie("IdAgenteVenda");

    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas,
    };

    axios
      .get(`${REACT_APP_API}elegibilidade/VidasRestantes`, { params })
      .then((res) => {
        const vidasrestantes = res.data;

        this.setState({ vidasrestantes });
      });
  }

  parametrosPlanos() {
    const IdAgenteVendas = retornarCookie("IdAgenteVenda");
    const Filial = retornarCookie("Filial");

    return {
      qtdVidas: this.props.oportunidade.QtdeVidas,
      qtdTitulos: this.props.oportunidade.QtdeVidasTit,
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas,
      MEI: false,
      Filial,
      cep: this.props.oportunidade.CEP.replace("-", ""),
    };
  }

  async listarPlanosMedicina() {
    this.setState({ exibeCarregamento: true });

    const params = this.parametrosPlanos();

    axios.get(`${REACT_APP_API}Planos/Medicina`, { params }).then((res) => {
      const planosMedicina = [
        ...res.data.map((x) => {
          if (x.DescricaoPlano.length > 30) {
            x.DescricaoPlano = x.DescricaoPlano.substring(0, 30) + "...";
          }
          return { ...x, Selecionado: false };
        }),
      ];

      const planosMedicinaSemDuplicatas = planosMedicina.filter((plano, index, self) => {
        const c = plano.CodigoPlano;

        return index === self.findIndex((p) => (
          p.CodigoPlano === c
        ));
      });

      this.setState({ planosMedicina: planosMedicinaSemDuplicatas });
      this.setState({ exibeCarregamento: false });

      if (planosMedicina.length <= 0) {
        this.setState({ existePlanoMedicina: false });
      }
    });
  }

  async listarPlanosOdonto() {
    this.setState({ exibeCarregamento: true });

    const params = this.parametrosPlanos();

    axios.get(`${REACT_APP_API}Planos/Odonto`, { params }).then((res) => {
      const planosOdonto = [
        ...res.data.map((x) => {
          if (x.DescricaoPlano.length > 30) {
            x.DescricaoPlano = x.DescricaoPlano.substring(0, 30) + "...";
          }
          return { ...x, Selecionado: false };
        }),
      ];

      const planosOdontoSemDuplicatas = planosOdonto.filter((plano, index, self) => {
        const c = plano.CodigoPlano;

        return index === self.findIndex((p) => (
          p.CodigoPlano === c
        ));
      });

      this.setState({ planosOdonto: planosOdontoSemDuplicatas });
      this.setState({ exibeCarregamento: false });

      if (planosOdonto.length <= 0) {
        this.setState({ existePlanoOdonto: false });
      }
    });
  }
  LimiteDistribuicaoVidas = (e) => {
    if (
      parseInt(e.target.value) > this.state.vidasrestantes ||
      parseInt(e.target.value) < 0
    ) {
      alert(
        "Não é possível destribuir mais do que " +
        this.state.vidasrestantes +
        " vida(s)."
      );
      localStorage.setItem("VidasDistribuicao", "");
      document.getElementById("numeroVidas").value = "";
      // reload da página para perder o estado atual
      window.location.reload();
    }

    if (parseInt(e.target.value) === 0) {
      localStorage.setItem("VidasDistribuicao", "");
      document.getElementById("numeroVidas").value = "";
      alert("Por favor insira um número maior que zero para prosseguir");
      // reload da página para perder o estado atual
      window.location.reload();
    }
  };

  Continuar = () => {
    // nome elegibilidade e numero de vidas são obrigatórios, mas podem não estar no state (por algum motivo)
    // olhar para os campos do formulário
    const valorNumeroVidas = document.getElementById("numeroVidas")?.value;
    const valorNomeElegibilidade = document.getElementById("nomeElegibilidade")?.value;
    if (!this.state.numeroVidas && valorNumeroVidas) {
      this.setState({ numeroVidas: valorNumeroVidas });
    }
    if (!this.state.nomeElegibilidade && valorNomeElegibilidade) {
      this.setState({ nomeElegibilidade: valorNomeElegibilidade });
    }
    if (!valorNumeroVidas && this.state.numeroVidas) {
      this.setState({ numeroVidas: undefined });
    }
    if (!valorNomeElegibilidade && this.state.nomeElegibilidade) {
      this.setState({ nomeElegibilidade: undefined });
    }

    const deveDesabilitarOBtnDeContinuar = this.permitirContinuar();
    if (!deveDesabilitarOBtnDeContinuar) {
      this.props.finalizarSelecaoPlanoElegibilidade(this.state);
    } else {
      alert("Verifique se todos os campos obrigatórios foram preenchidos.");
    }
  };

  permitirContinuar = () => {
    if (this.state.planosOdonto.length > 0) {
      const desabilitar = !(
        this.state.nomeElegibilidade &&
        this.state.numeroVidas &&
        (this.state.planosMedicina.filter((x) => x.Selecionado).length > 0 ||
        this.state.planosOdonto.filter((x) => x.Selecionado).length > 0)
      );
      return desabilitar;
    } else {
      const desabilitar = !(
        this.state.nomeElegibilidade &&
        this.state.numeroVidas &&
        this.state.planosMedicina.filter((x) => x.Selecionado).length > 0
      );
      return desabilitar;
    }
  };

  onChangePlanoMedicina = (codigoPlano) => {
    const planosMedicina = this.state.planosMedicina.map((x) => {
      if (codigoPlano === x.CodigoPlano) {
        x.Selecionado = !x.Selecionado;
      }
      return { ...x };
    });

    this.setState({ planosMedicina });
  };

  onChangePlanoOdonto = (codigoPlano) => {
    const planosOdonto = this.state.planosOdonto.map((plano) => {
      if (codigoPlano === plano.CodigoPlano) {
        plano.Selecionado = !plano.Selecionado;
      }
      return plano;
    });
    this.setState({ planosOdonto });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (
      e.target.name === "numeroVidas" &&
      e.target.value <= this.state.vidasrestantes
    ) {
      localStorage.setItem("VidasDistribuicao", e.target.value);
    }
  };

  async VerificarHomonimo(nomeAtual) {
    const IdAgenteVendas = retornarCookie("IdAgenteVenda");

    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas,
    };

    axios
      .get(`${REACT_APP_API}elegibilidade/elegibilidadesResumida`, { params })
      .then((res) => {
        const elegibilidades = [
          ...res.data.map((x) => {
            const ListaPlanos = [...x.Planos].toString();
            return { ...x, ListaPlanos };
          }),
        ];

        this.setState({ elegibilidades });

        var filter = elegibilidades.find(
          (elegibilidade) =>
            elegibilidade.Nome.toUpperCase() === nomeAtual.toUpperCase()
        );

        if (filter.Nome.toUpperCase() === nomeAtual.toUpperCase()) {
          alert("Não é possível gerar duas elegibilidades com um mesmo nome.");
          document.getElementById("nomeElegibilidade").value = "";
          // reload da página para perder o estado atual
          window.location.reload();
        }
      });
  }

  ValidarNomeElegibilidade = async (e) => {
    var NomeAtual = e.target.value;
    await this.VerificarHomonimo(NomeAtual);
  };

  render() {
    const { oportunidade } = { ...this.props };
    const { planosMedicina, planosOdonto } = { ...this.state };

    return (
      <div className="row container">
        {this.state.exibeCarregamento && <Loader />}

        <HeaderPage />
        <div className="col s5 m5 l5 offset-s3 offset-m3 offset-l3">
          <div className="input-field col s12">
            <label for="nomeElegibilidade">Nome Elegibilidade</label>
            <input
              type="text"
              id="nomeElegibilidade"
              name="nomeElegibilidade"
              value={this.state.nomeElegibilidade}
              onBlur={(e) => {
                this.ValidarNomeElegibilidade(e);
              }}
              onChange={(e) => this.onChange(e)}
              size={100}
            />
          </div>
          <div className="input-field col s12">
            <label for="numeroVidas">Número de Vidas</label>
            <input
              onKeyDown={(e) =>
                ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
              }
              onWheel={() => document.activeElement.blur()}
              type="number"
              id="numeroVidas"
              name="numeroVidas"
              value={this.state.numeroVidas}
              onChange={(e) => this.onChange(e)}
              onBlur={(e) => this.LimiteDistribuicaoVidas(e)}
            />
          </div>

          <div className="input-field col s12">
            <b>Seleção de planos para o grupo de vidas</b>
            <br />
            <br />
            {planosMedicina.length > 0 && (
              <>
                <div className="row">Medicina</div>
                <div className="row">
                  {planosMedicina.map((plano) => (
                    <>
                      <div className="col s5 m5 l5">
                        <ChoosePlan
                          title={plano.CodigoPlano}
                          description={plano.DescricaoPlano}
                          checked={plano.Selecionado}
                          onChange={(codigoPlano) =>
                            this.onChangePlanoMedicina(plano.CodigoPlano)
                          }
                        />
                      </div>
                      <div className="col s1 m1 l1">&nbsp;</div>
                    </>
                  ))}
                </div>
              </>
            )}
            {planosOdonto.length > 0 && (
              <>
                <div className="row">Odontologia</div>
                <div className="row">
                  {planosOdonto.map((plano) => (
                    <>
                      <div className="col s5 m5 l5">
                        <ChoosePlan
                          title={plano.CodigoPlano}
                          description={plano.DescricaoPlano}
                          checked={plano.Selecionado}
                          onChange={(codigoPlano) =>
                            this.onChangePlanoOdonto(plano.CodigoPlano)
                          }
                        />
                      </div>
                      <div className="col s1 m1 l1">&nbsp;</div>
                    </>
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="col s6 m6 l6 right-align">
            <br />
            <button
              type="button"
              onClick={() =>
                this.props.controlaVisualizacao("ListaElegibilidadesPage")
              }
              className="OmintButton"
            >
              Voltar
            </button>
          </div>
          <div className="col s6 m6 l6 right-align">
            <br />
            <button
              type="button"
              className="OmintButton"
              disabled={this.permitirContinuar()}
              onClick={() => this.Continuar()}
            >
              <a className="WhiteText">Continuar</a>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
